import { Animal } from "./types";
import { useCreateAnimalMutation, useDeleteAnimalMutation } from "./api";

export const useAnimalService = () => {
  const [createAnimal, { isLoading: isCreating }] = useCreateAnimalMutation();
  const [deleteAnimal, { isLoading: isDeleting }] = useDeleteAnimalMutation();

  const addAnimal = async (
    animal: Omit<Animal, "id">,
    files: FileList | null
  ) => {
    try {
      await createAnimal({ animal, files });
    } catch (error) {
      console.error("Failed to add animal:", error);
    }
  };

  const removeAnimal = async (id: string) => {
    try {
      await deleteAnimal(id);
    } catch (error) {
      console.error("Failed to delete animal:", error);
    }
  };

  return { addAnimal, removeAnimal, isCreating, isDeleting };
};
